module.exports = __webpack_public_path__ + "static/media/MHRP29N0004.f5920905.svg";